import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, ArrowRight } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Badge } from '../../../components/ui/badge';
import { adminService } from '../../../services/adminService';

const money = (n) => `$${Math.abs(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;

const BAND_CHIP = {
  at_risk: 'bg-rose-100 text-rose-800 border-rose-200',
  watch: 'bg-amber-100 text-amber-800 border-amber-200',
};

export const AtRiskClientsCard = () => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    let alive = true;
    adminService.getAtRiskClients(3)
      .then((d) => { if (alive) setData(d); })
      .catch(() => { if (alive) setData(null); });
    return () => { alive = false; };
  }, []);

  if (!data || (data.clients || []).length === 0) return null;

  return (
    <Card className="border-rose-200" data-testid="at-risk-clients-card">
      <CardHeader className="pb-2 flex flex-row items-center justify-between gap-3">
        <CardTitle className="text-base flex items-center gap-2">
          <AlertTriangle className="h-4 w-4 text-rose-600" /> Clients to look at this month
        </CardTitle>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate('/admin/reports/client-performance')}
          data-testid="at-risk-view-report-btn"
        >
          Full report <ArrowRight className="h-4 w-4 ml-1" />
        </Button>
      </CardHeader>
      <CardContent className="space-y-3">
        {data.clients.map((c) => (
          <button
            key={c.client_account_id}
            type="button"
            onClick={() => navigate(
              `/admin/reports/client-performance?tab=scorecards&client=${c.client_account_id}`,
            )}
            className="w-full text-left rounded-lg border border-gray-200 p-3 hover:border-amber-300 hover:bg-amber-50/40 transition-colors"
            data-testid={`at-risk-row-${c.client_account_id}`}
          >
            <div className="flex items-center justify-between gap-3">
              <span className="font-medium text-gray-900 truncate">{c.company_name}</span>
              <Badge variant="outline" className={BAND_CHIP[c.status_band] || ''}>
                {c.status_band === 'at_risk' ? 'At risk' : 'Watch'}
              </Badge>
            </div>
            <p className="text-xs text-gray-600 mt-1">
              {c.sell_through_pct !== null ? `${c.sell_through_pct}% sell-through` : 'no deliveries'}
              {' · '}{money(c.credit_given)} credits
              {c.waste_cost ? ` · ${money(c.waste_cost)} waste` : ''}
              {' · '}{money(c.net_revenue)} net
            </p>
          </button>
        ))}
        {data.total_flagged > data.clients.length && (
          <p className="text-xs text-gray-500">
            {data.total_flagged - data.clients.length} more flagged this month.
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export default AtRiskClientsCard;
